module.exports = __webpack_public_path__ + "img/loader2.a6208338.gif";